// import React, { createContext, useContext, useEffect, useState } from "react";
// import { getFullParentProfile } from "../services/parentRegistrationService";

// const ParentContext = createContext();

// export const ParentProvider = ({ children }) => {
//   const [parentData, setParentData] = useState(null);
//   const [loading, setLoading] = useState(true);

//   const fetchParentData = async () => {
//     try {
//       const res = await getFullParentProfile();
//       setParentData(res.data.data);
//     } catch (err) {
//       console.error("Error fetching parent data:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchParentData();
//   }, []);

//   return (
//     <ParentContext.Provider value={{ parentData, loading, fetchParentData }}>
//       {children}
//     </ParentContext.Provider>
//   );
// };

// export const useParent = () => useContext(ParentContext);

import React, { createContext, useContext, useEffect, useState } from "react";
import { getFullParentProfile } from "../services/parentRegistrationService";

const ParentContext = createContext();

export const ParentProvider = ({ children }) => {
  const [parentData, setParentData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchParentData = async () => {
    // ✅ Check if token exists before making API call
    const token =
      localStorage.getItem("token") || sessionStorage.getItem("token");
    const user = JSON.parse(
      localStorage.getItem("user") || sessionStorage.getItem("user"),
    );

    // ✅ Only fetch if user is logged in AND has parent role
    // (password login's user object uses `role`; social login's uses `user_type`)
    if (!token || (user?.role !== "parent" && user?.user_type !== "parent")) {
      console.log(
        "Not a parent user or not logged in, skipping parent data fetch",
      );
      setLoading(false);
      return;
    }

    try {
      const res = await getFullParentProfile();
      if (res.data?.success) {
        setParentData(res.data.data);
      }
    } catch (err) {
      console.error("Error fetching parent data:", err);
      // ✅ Don't throw error for non-parent users
      if (err.response?.status === 403 || err.response?.status === 401) {
        console.log("Parent authentication failed - user may not be a parent");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchParentData();
  }, []);

  // ✅ Add function to refresh parent data (useful after login)
  const refreshParentData = async () => {
    setLoading(true);
    await fetchParentData();
  };

  return (
    <ParentContext.Provider
      value={{ parentData, loading, fetchParentData, refreshParentData }}
    >
      {children}
    </ParentContext.Provider>
  );
};

export const useParent = () => useContext(ParentContext);
